import { $rtkApi } from 'shared/api';

export interface NaiveDevice {
  id: number;
  name: string | null;
  status: 'PROVISIONING' | 'ACTIVE' | 'REVOKE_PENDING' | 'REVOKED';
  expiredAt: string;
}

const devicesApi = $rtkApi.injectEndpoints({
  endpoints: (build) => ({
    fetchNaiveDevices: build.query<NaiveDevice[], null>({
      query: () => '/api/privategate/devices',
      providesTags: ['UserInfo'],
    }),
    createNaiveDevice: build.mutation<NaiveDevice, { name?: string }>({
      query: (body) => ({ url: '/api/privategate/devices', method: 'POST', body }),
      invalidatesTags: ['UserInfo'],
    }),
    deleteNaiveDevice: build.mutation<NaiveDevice, number>({
      query: (id) => ({ url: `/api/privategate/devices/${id}`, method: 'DELETE' }),
      invalidatesTags: ['UserInfo'],
    }),
  }),
});

export const { useFetchNaiveDevicesQuery, useCreateNaiveDeviceMutation, useDeleteNaiveDeviceMutation } = devicesApi;
